// extracted by mini-css-extract-plugin
export default {"modal":"UnmarkAsMultipleModal__modal___ZVY1a"};